import { useNavigate } from 'react-router';
import './css/BackButton.css';
const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button
      className="back-button"
      onClick={() => navigate(-1)}
      aria-label="חזרה"
    >
      ←
    </button>
  );
};

export default BackButton;